export const PARTNER_ACCOUNT_TABLE = "partnerAccounts"
// Indexed fields: id (PK), companyId (multi-tenant scan), partnerId
// (1:1 with partner — every recap/dashboard hit looks up by partner first),
// syncId (delta cursors).
export const PARTNER_ACCOUNT_TABLE_SCHEMA =
  "id, companyId, partnerId, syncId, [companyId+partnerId]"
